import type { IUser } from '@/interfaces/users/IUser'
import Base from '../Base'
import type { IUserNextOfKinDetail } from '@/interfaces/users/IUserNextOfKinDetail'
import type { IAddress } from '@/interfaces/IAddress'
import Address from '../Address'
import NextOfKinDetail from '../NextOfKinDetail'

class User extends Base implements IUser {
  createdAt?: string

  updatedAt?: string

  archivedAt?: string

  initials?: string

  userName: string

  name: string
  
  email?: string

  roles: Array<string>

  designation?: string

  teamTitle?: string

  employeeCode?: string

  phoneNumber?: string

  alternatePhoneNumber?: string

  dateOfBirth?: string

  nextOfKinDetail: IUserNextOfKinDetail

  address: IAddress

  userDisplayName: string

  constructor(user?: any) {
    super(user)
    this.createdAt = user?.createdAt
    this.updatedAt = user?.updatedAt
    this.archivedAt = user?.archivedAt
    this.initials = user?.initials
    this.userName = user?.userName
    this.name = user?.name ?? null
    this.email = user?.email ?? null
    this.roles = user?.roles ?? []
    this.designation = user?.designation ?? null
    this.teamTitle = user?.teamTitle ?? null
    this.employeeCode = user?.employeeCode ?? null
    this.phoneNumber = user?.phoneNumber ?? null
    this.alternatePhoneNumber = user?.alternatePhoneNumber ?? null
    this.dateOfBirth = user?.dateOfBirth ?? null
    this.nextOfKinDetail = new NextOfKinDetail(user?.nextOfKinDetail)
    this.address = new Address(user?.address)
    this.userDisplayName = user?.userDisplayName ?? user?.name
  }
}

export default User
